import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class EditorContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { src, width, height, shortTitle, shortTitleUrl, longTitle, longTitleUrl },
        } = this.props;

        return (
            <div className={styles.editor_box}>
                <a href={shortTitleUrl} target="_blank" rel={rel}>
                    <img src={src} width={width} height={height} alt={shortTitle} title={shortTitle} />
                </a>
                <div className={styles.short_title_bg} />
                <div className={styles.short_title}>
                    <a href={shortTitleUrl} target="_blank" rel={rel}>
                        {shortTitle}
                    </a>
                </div>
                <div className={styles.long_title_bg} />
                <div className={styles.long_title}>
                    <a href={longTitleUrl} target="_blank" rel={rel}>
                        {longTitle}
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(EditorContent);
